do ->
  'use strict'

  # ANGULAR CONTROLLER FUNCTION
  ApplicationController = () ->
    vm = @

    ### CONSTANTS ###

    ### VARIABLES VIEW MODEL ###

    ### VARIAVEIS PRIVATE ###

    ### WATCHES ###

    # INIT SETUP
    init = () =>
      return

    ### METHODS PRIVATE ###


    ### METHODS VIEW MODEL ###

    # CALL INIT SETUP
    init()

    return


  # ANGULAR CONTROLLER
  angular.module('mainApp').controller 'ApplicationController', ApplicationController

  # ANGULAR INJECT DEPENDENCIES
  ApplicationController.$inject = []

  # END BLOCK SCRIPT
  return
